import React from 'react';
import PropTypes from 'prop-types';
import style from './RaiseTicketPopup.module.scss';

export default function RaiseTicketPopup({
  setShowTicketModal,
  optionList,
  setSelectedOption,
  selectedOption,
  handleSubmit,
}) {
  const handleSelect = (key) => {
    setSelectedOption((prev) => (prev === key ? null : key));
  };

  return (
    <>
      <section className={`modal ${style.Modal}`}>
        <div className={`${style.Content} modal_content fadeInUpTop `}>
          <div
            className="modal_header pl-20 pr-20 pt-10"
            style={{ paddingLeft: '36px', paddingTop: '16px', paddingBottom: '16px' }}
          >
            <div className={`${style.HeadCenter} modal_head_center font18 fw600 color111`}>
              Reasons for raise ticket
            </div>
            <div className={`${style.HeadRight} modal_head_right`}>
              <div className={`${style.HeadClose} modal_close icon`} onClick={() => setShowTicketModal(false)} />
            </div>
          </div>
          <div className="modal_body p-30 pt-0">
            <ul className={`${style.table__row}`}>
              {optionList &&
                Object.keys(optionList).map((key, index) => (
                  <li key={index} className={`${style.table__item}`} data-label={`column_${index}`}>
                    <div className={`${style.item}`}>
                      <label className={`${style.animcheck}`}>
                        <input
                          className={`${style.animinput}`}
                          type="checkbox"
                          checked={selectedOption === key}
                          onChange={() => handleSelect(key)}
                        />
                        <div className={`${style.animlabel}`}>
                          <span className={`${style.animicon}`} />
                        </div>
                      </label>
                      <div className={`${style.item}`}>{key}</div>
                    </div>
                  </li>
                ))}
            </ul>
            <div className={`${style.BtnGroup} mt-20`}>
              <button
                className={`${style.Button} bluefill_animate font16 fw500 colorFFF`}
                style={{
                  background: !selectedOption && 'gray',
                  cursor: !selectedOption && 'not-allowed',
                }}
                onClick={() => {
                  handleSubmit();
                }}
              >
                Raise Ticket
              </button>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
RaiseTicketPopup.propTypes = {
  setShowTicketModal: PropTypes.func,
  optionList: PropTypes.object,
  setSelectedOption: PropTypes.func,
  selectedOption: PropTypes.string,
  handleSubmit: PropTypes.func,
};
